/* RW: Default collection to "In stock" (works with AJAX navigation) */
(function () {
  function isCollectionPage() {
    return !!document.querySelector('[data-section-type="collection"]');
  }

  function applyInStockDefault() {
    if (!isCollectionPage()) return;

    var url = new URL(window.location.href);
    var params = url.searchParams;

    // If availability already set, do nothing
    if (params.has('filter.v.availability')) return;

    // If user explicitly wants OOS shown, do nothing
    if (params.get('show_oos') === '1') return;

    // Prevent loops PER URL
    var key = 'rw_avail_defaulted:' + window.location.pathname + window.location.search;
    if (sessionStorage.getItem(key) === '1') return;
    sessionStorage.setItem(key, '1');

    params.set('filter.v.availability', '1');
    url.search = params.toString();

    window.location.replace(url.toString());
  }

  function schedule() {
    setTimeout(applyInStockDefault, 50);
    setTimeout(applyInStockDefault, 250);
  }

  // Run on first load
  document.addEventListener('DOMContentLoaded', schedule);

  // Catch Shopify theme editor / dynamic section loads
  document.addEventListener('shopify:section:load', schedule);

  // Catch back/forward
  window.addEventListener('popstate', schedule);

  // Catch most AJAX nav systems by watching DOM changes
  var mo = new MutationObserver(function () {
    if (isCollectionPage()) schedule();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
